"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noteData = {
    updatedAt: 1571076479893,
    data: [
        {
            packageName: 'elm-webgl',
            projectFolder: 'notes/elm-webgl',
            reviewCategory: 'prototypes'
        },
        {
            packageName: 'with-sand-dance',
            projectFolder: 'notes/with-sand-dance',
            reviewCategory: 'prototypes'
        }
    ]
};
